import { WhistleBlowerReport } from "@/models/WhistleBlowerReport";
import PaginatedResponse from "@/models/PaginatedResponse";

export const WhistleBlowerReportRequest = (argWhistleBlowerReport) => {
  let whistleblowerreport = argWhistleBlowerReport.copy();

  if (whistleblowerreport.company) {
    whistleblowerreport.company = whistleblowerreport.company.id;
  }
  return whistleblowerreport;
};

export const WhistleBlowerReportResponse = (whistleblowerreport) => {
  return new WhistleBlowerReport(whistleblowerreport);
};

export const WhistleBlowerReportsResponse = (whistleblowerreports) => {
  return whistleblowerreports.map((c) => WhistleBlowerReportResponse(c));
};

export const PaginatedWhistleblowerReportsResponse = (data) => {
  let response = new PaginatedResponse(data);
  response.results = response.results.map((i) => WhistleBlowerReportResponse(i));
  return response;
};
